
export const Likert = ({ text, value, onChange, testid, labels }) => (
  <div className="card-soft likert-card p-6 md:p-7 fade-up">
    <p className="text-navy text-lg leading-relaxed">{text}</p>
    <div className="grid grid-cols-5 gap-2 mt-5" role="radiogroup">
      {[1, 2, 3, 4, 5].map((n) => (
        <button key={n} type="button" role="radio" aria-checked={value === n} aria-label={`${n} - ${labels[n - 1]}`}
          onClick={() => onChange(n)} data-testid={`${testid}-${n}`}
          className={`likert-opt ${value === n ? "is-on" : ""} rounded-xl py-3 border flex flex-col items-center gap-1 transition-[background-color,transform,border-color] duration-200 ${value === n ? "bg-navy text-white border-transparent -translate-y-0.5" : "bg-white text-navy border-line hover:border-teal"}`}>
          <span className="font-display text-lg font-semibold">{n}</span>
          <span className={`text-[10px] sm:text-xs leading-tight text-center px-1 ${value === n ? "text-white/80" : "text-muted-ink"}`}>{labels[n - 1]}</span>
        </button>
      ))}
    </div>
  </div>
);
